import { ApiRequestError } from "@/lib/api/client";
import { getErrorMessage } from "@/lib/api/errorMessage";

/** Renders any caught error as a readable message. Uses the same
 * normalization the global mutation-error toast does (getErrorMessage)
 * rather than reading `.appError.message` directly - a timeout/offline/
 * connection-failure error carries no message of its own (see
 * lib/api/client.ts), so reading it raw renders a blank banner. */
export function ErrorMessage({ error, className }: { error: unknown; className?: string }) {
  const message =
    error instanceof ApiRequestError
      ? getErrorMessage(error)
      : error instanceof Error && error.message
        ? error.message
        : "Something went wrong.";

  return (
    <div className={className ?? "rounded-lg border border-red-200 bg-red-50 px-4 py-3 text-sm text-red-700"}>
      {message}
    </div>
  );
}
